import { AxiosResponse } from 'axios';
import httpService from '../httpService'
import { Dayjs } from 'dayjs';
import { Filter, ValidityExtensionListResponse } from 'pages/validityExtension/models';


interface ValidityExtension {
    planId: string;
    planName?: string;
    purchasedAt: [Dayjs, Dayjs];
    requiredExpiry: Dayjs;
    reason: string;
}


export function extendValidity(
    validityExtensionData: FormData,
): Promise<AxiosResponse<ValidityExtension>> {
    return httpService.post(`/v9/bulk-validity-extend/`, validityExtensionData)
}

export function getValidityList(filter: Filter): Promise<AxiosResponse<ValidityExtensionListResponse>> {
    return httpService.get(`/v9/bulk-validity-extend/`, {
        params: filter
    })
}